/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：741
 */

module.exports = {
  highlight: "style_highlight__WTK3C",
  outline: "style_outline__3aezC",
  actorSelectedBox: "style_actorSelectedBox__5dKzJ",
  actorAddon: "style_actorAddon__1tQxL",
  actorStar: "style_actorStar__h_A7S"
}
